<template>
  <div class="container-fluid p-0">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-12">
          <nav class="navbar navbar-expand-lg bg-body-tertiary px-3">
            <div class="container-fluid p-0 d-flex">
              <div>
                <img
                  src="../assets/reactfolio-low-resolution-logo-color-on-transparent-background.svg"
                  alt=""
                  height="30px"
                />
              </div>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div
                class="collapse navbar-collapse position-links"
                id="navbarSupportedContent"
              >
                <ul class="navbar-nav me-auto mb-2 mb-lg-0 ">
                  <li>
                    <a
                      class="nav-link"
                      href="https://www.linkedin.com/in/tushargautam03"
                      target="__blank"
                    >
                      <i class="bi bi-linkedin fs-4"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      class="nav-link"
                      href="https://github.com/Tushar-Gautam"
                      target="__blank"
                      ><i class="bi bi-github fs-4"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      class="nav-link"
                      href="https://medium.com/@tushargautam0306"
                      target="_blank"
                    >
                      <i class="bi bi-medium fs-4"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <div style="color:white" class="ui ">
      <div class="waviy">
        Better
        <strong style="color:black;fontSize:18px;marginRight:6px"> UI </strong>
        <span style="--i:1">L</span>
        <span style="--i:2">o</span>
        <span style="--i:3">a</span>
        <span style="--i:4">d</span>
        <span style="--i:5">i</span>
        <span style="--i:6">n</span>
        <span style="--i:7">g</span>
        <span style="--i:8">.</span>
        <span>&#x231B;</span>
      </div>
    </div>
    <div class="container-fluid p-0">
      <div class="row mx-auto mx-2">
        <div class="col-md-4">
          <div class="name">
            <div class="heading"></div>
            <AllProjectNames @displayNewProject="displayNewProject" />
          </div>
        </div>
        <div class="col-md-8">
          <div class="info">
            <ProjectsInfo :projectToBeDisplayed="projectToBeDisplayed" />
          </div>
        </div>
      </div>

      <div class="row justify-content-center my-5">
        <div class="col-8">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item ">
              <h2 class="accordion-header ">
                <button
                  class="accordion-button collapsed bg-warning"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  What is Website displaying?
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  This is a portfolio projects website showcasing all the react
                  projects that i have Done.
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button
                  class="accordion-button collapsed  bg-warning"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  Which tech stack is used to make this website?
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  This website is made using Vue Js,bootStrap and SASS is
                  used.Also,<strong>Vue router</strong> is used to display
                  diffrent projects when a project is clicked in the List.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid p-0">
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <footer
              class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top"
            >
              <div class="col-md-4 d-flex align-items-center">
                <a
                  href="/"
                  class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1"
                >
                  <svg class="bi" width="30" height="24">
                    <use xlink:href="#bootstrap"></use>
                  </svg>
                </a>
                <span class="mb-3 mb-md-0 text-body-secondary">
                  <img
                    src="../assets/building.svg"
                    alt="buiding icon"
                    width="50px"
                    height="50px"
                  />
                  Developed By Tushar Gautam &copy;
                </span>
              </div>

              <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
                <li class="ms-3">
                  <a class="text-body-secondary" href="#"
                    ><svg class="bi" width="24" height="24">
                      <use xlink:href="#twitter"></use></svg
                  ></a>
                </li>
                <li class="ms-3">
                  <a
                    class="text-body-secondary"
                    href="https://github.com/Tushar-Gautam"
                    target="_blank"
                    ><i class="bi bi-github fs-4"></i
                  ></a>
                </li>
                <li class="ms-3">
                  <a
                    class="text-body-secondary"
                    href="https://www.linkedin.com/in/tushargautam03"
                    target="_blank"
                  >
                    <i class="bi bi-linkedin fs-4"></i>
                  </a>
                </li>
                <li class="ms-3">
                  <a
                    class="text-body-secondary"
                    href="https://medium.com/@tushargautam0306"
                    target="_blank"
                  >
                    <i class="bi bi-medium fs-4"></i>
                  </a>
                </li>
              </ul>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AllProjectNames from "./AllProjectNames.vue";
import ProjectsInfo from "./ProjectsInfo.vue";

export default {
  name: "App",
  components: {
    AllProjectNames,
    ProjectsInfo
  },
  data() {
    return {
      projectToBeDisplayed: {}
    };
  },
  methods: {
    displayNewProject({ projectLink }) {
      this.projectToBeDisplayed = projectLink;
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;600;800&display=swap");

* {
  box-sizing: border-box;
  margin: 0;
}
html {
  scroll-behavior: smooth;
}
body {
  font-family: "Inter", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
  color: #111;
  overflow-x: hidden !important;
}
::-webkit-scrollbar {
  width: 0.4rem;
}
::-webkit-scrollbar-track {
  background: #fff;
}

::-webkit-scrollbar-thumb {
  background: #2a9d8f;
  border-radius: 1rem;
}
.navbar {
  background-color: #16425b !important;
}
.nav-link,
.nav-link:focus {
  color: ivory;
}

.nav-link:hover {
  color: #1ebbd7;
}
.ui {
  width: 90%;
  border-radius: 0 0 5px 5px;
  height: 22px;
  font-size: 16px;
  margin: 0 auto;
  text-align: center;
  background: #14453d;
  opacity: 0.7;
}
.waviy {
  position: relative;
  background: #14453d;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.waviy span {
  position: relative;
  display: inline-block;
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
  animation: flip 2s infinite;
  animation-delay: calc(0.2s * var(--i));
}
@keyframes flip {
  0%,
  80% {
    transform: rotateY(360deg);
  }
}
@media screen and (min-width: 992px) {
  .position-links {
    position: absolute;
    right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue